import { render, staticRenderFns } from "./Uppy.vue?vue&type=template&id=3a9600ee"
import script from "./Uppy.vue?vue&type=script&lang=js"
export * from "./Uppy.vue?vue&type=script&lang=js"
import style0 from "uppy/dist/uppy.min.css?vue&type=style&index=0&prod&lang=css&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports